import { useTranslation } from 'react-i18next';

import { TextField } from 'fields';

export default function PackNumber() {
  const { t } = useTranslation('CreateCropOrder', { keyPrefix: 'ProductForm' });

  return (
    <TextField
      name="packagedItemQty"
      label={t('labels.packNumber')}
      placeholder={t('placeholders.packNumber')}
      required
    />
  );
}
